import React from 'react'
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import transactionComplete from "../../../../../../assets/images/transfercomplete.png"
import { appTheme, showKudzuPlusPrompt } from '../../../../../../helpers/utils/Utils';
import { useSelector } from 'react-redux';


const ScheduledTransfer = ({ onCanelTranfer,fromAccountType ,showPlusAlertforScheduleTransfer}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isinSavings = location.pathname.toLocaleLowerCase().includes("savings");
  const cards = useSelector(state => JSON.parse(state.userCards));
  const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const isShowKudzuPlusPrompt = showKudzuPlusPrompt(loggedResponse);
  const appThemeData = appTheme(kudzuPlusTrue)

  const handleBackToService = () => {
    var fromAccountName;
    if (location?.pathname.toLocaleLowerCase().includes("spending")) {
      fromAccountName = "Spending"
    } else if (location?.pathname.toLocaleLowerCase().includes("savings")) {
      fromAccountName = "Savings"
    }

    if (fromAccountType != '' && (!kudzuPlusTrue && isShowKudzuPlusPrompt) ) {
      if (fromAccountType != '' &&  fromAccountType == 'Spending' && isinSavings) {
         showPlusAlertforScheduleTransfer()
    }else{
      if (fromAccountType != undefined && fromAccountType != null) {
        navigate(`/AccountServices/${fromAccountType}`);
      } else {
        navigate('/AccountServices');
      }
    }
      
    } else {
      //   navigate('/AccountServices')
      if (fromAccountType != undefined && fromAccountType != null) {
        navigate(`/AccountServices/${fromAccountType}`);
      } else {
        navigate('/AccountServices');
      }
    }
 
  }
  return (
    <div className=' flex flex-col justify-center items-center w-full'>
      <p className='font-hanken-grotesk text-[var(--modal-text-heading-clr)] text-[16px] font-[400] sm:font-[500] leading-[24px] sm:text-[12px] sm:leading-[18px] md:text-[18px] md:leading-[28px] '>{t("scheduled_fund_transfer_notify_msg")}</p>

      <img src={appThemeData.TransactionComplete} alt="complete" className={`${kudzuPlusTrue ? 'my-12 mx-auto' :'lg:w-[220px] lg:h-[220px] md:w-[170px] md:h-[170px] w-[129px] h-[129px] sm:m-auto mx-auto'} block`} />
      <div className=' flex flex-col justify-center items-center w-full'>

        <div className=' flex flex-col justify-center items-center gap-4 w-full'>
          <button autoFocus class="focus:outline-none   font-hanken-grotesk  font-[500] sm:font-bold leading-[24px]
          lg:text-[18px] md:text-[17px] 
          sm:text-[15px] text-[16px] sm:leading-[12px]  md:leading-[16px] bg-[#2965FB]
            text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full" onClick={handleBackToService}>{t("back_to_account_services")}</button>
          <button class="font-hanken-grotesk lg:text-[18px] md:text-[17px] 
 sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] 
          sm:leading-[12px] md:leading-[16px]  text-[var(--transferBtnTextColor)] cursor-pointer  px-2 py-4  w-full" onClick={() => onCanelTranfer(true)}>{t("cancel_tranfer")}</button>


        </div>
      </div>

    </div>
  )
}

export default ScheduledTransfer